import {Route, Routes} from "react-router-dom";
import React from "react";
import './App.css';

import {NoMatchView} from "./pages/NoMatchView";
import Veolia from "./pages/Veolia";
import DPE from "./pages/dpeByIris/DPE";
import DPEMenu from "./pages/DPEMenu";

export default function App() {


    return (
        <Routes>
            <Route path="/">
                <Route path="/" element={<DPE/>}/>
                <Route path="/menu" element={<DPEMenu/>}/>
                <Route path="/veolia/:id" element={<Veolia/>}/>
                <Route path="*" element={<NoMatchView/>}/>
            </Route>
        </Routes>
    )


}
